import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import EntityDetailsPage from "../../../components/EntityDetails/EntityDetailsPage";
import FlightPlan, { FlightPlanQuickAdd, createFlightPlanFromFlightPlanQuickAdd, getFlightPlanAddDisplayInfo } from "../../../models/flightPlan";

function QuickAddFlightPlanPage() {
    const navigate = useNavigate();
    const { mode } = useParams();
    const [searchParams] = useSearchParams();

    //Rules picked in the chooser (/fpls/quickadd/vfr | /fpls/quickadd/ifr?rules=Y|Z). They decide which
    //saved routes the picker offers and what the created plan files — an IFR plan can therefore be
    //started with no route at all and have one planned in the full form afterwards.
    const presetRules = (searchParams.get("rules") ?? "").toUpperCase();
    const flightRules: FlightPlan["flightRules"] | undefined =
        mode === "ifr" ? (presetRules === "Y" || presetRules === "Z" ? presetRules : "I") : mode === "vfr" ? "V" : undefined;

    const flightPlanAdd: FlightPlanQuickAdd = {};

    const goBack = () => {
        navigate("/fpls")
    }

    const proceedToFlightPlanDetails = async (flightPlanAdd: FlightPlanQuickAdd) => {
        navigate("/fpls/add", {state: {flightPlan: createFlightPlanFromFlightPlanQuickAdd(flightPlanAdd, flightRules)}})
        return flightPlanAdd
    }

    return (
        <EntityDetailsPage
            entity={flightPlanAdd}
            handleClose={goBack}
            displayInfo={getFlightPlanAddDisplayInfo(flightRules)}
            dispatchSaveEntity={proceedToFlightPlanDetails}
        />
    )
}

export default QuickAddFlightPlanPage;
